import axios from "../../axios";

const api = {
  getTransportTypes(accessToken) {
    const config = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get("/transportation/transport-types", config).then(({ data }) => data);
  },

  attachFileToCategory({ questionnaireId, categoryId, data }, accessToken) {
    const headers = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.post(`/attachments/questionnaire/${questionnaireId}/category/${categoryId}/upload`, data, headers).then(({ data }) => data);
  },

  getCategoryAttachment({ attachmentId }, accessToken) {
    const config = {
      responseType: "arraybuffer",
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get(`/attachments/${attachmentId}/questionnaire`, config)
      .then(({ data, headers }) => {
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        const defaultFileName = headers["content-disposition"]?.split("filename=")?.[1] ?? "Attachment";
        link.href = url;
        link.setAttribute("download", defaultFileName);
        document.body.appendChild(link);
        link.click();
        return true;
      });
  },

  deleteCategoryAttachment({ attachmentId }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.delete(`/attachments/${attachmentId}/questionnaire`,
      headers).then(({ data }) => data);
  }
};

export default api;